(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
function mapcutsFaq(){document.querySelectorAll('[data-mc-faq]:not([data-ready])').forEach(root=>{const nodes=[...root.children];const questions=nodes.filter(node=>/^\s*\d+[.)]\s/.test(node.textContent.trim())&&node.textContent.includes('?'));if(!questions.length)return;root.dataset.ready='true';root.classList.add('mc-faq');let answer=null;nodes.forEach(node=>{if(questions.includes(node)){const details=document.createElement('details');const summary=document.createElement('summary');summary.textContent=node.textContent.trim().replace(/^\d+[.)]\s*/,'');answer=document.createElement('div');answer.className='mc-faq-answer';details.append(summary,answer);root.insertBefore(details,node);node.remove();}else if(answer){answer.append(node);}});});}mapcutsFaq();document.addEventListener('shopify:section:load',mapcutsFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapcuts-for-you"] && !Shopify.designMode) return;
  try {
    
function mapcutsInterests(){document.querySelectorAll('.mc-for-you:not([data-ready])').forEach(section=>{section.dataset.ready='true';const controls=section.querySelector('.mc-interest-controls');if(!controls)return;controls.hidden=false;const cards=[...section.querySelectorAll('[data-category]')];controls.querySelectorAll('button').forEach(button=>{if(button.dataset.interest!=='all'&&!cards.some(card=>card.dataset.category===button.dataset.interest))button.hidden=true;button.addEventListener('click',()=>{controls.querySelectorAll('button').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));cards.forEach(card=>card.hidden=button.dataset.interest!=='all'&&card.dataset.category!==button.dataset.interest);section.querySelectorAll('[data-browse]').forEach(link=>link.hidden=link.dataset.browse!==button.dataset.interest);const status=section.querySelector('[data-interest-status]');status.textContent=status.dataset.message+': '+button.textContent;section.querySelector('.mc-interest-products').scrollLeft=0;});});});}mapcutsInterests();document.addEventListener('shopify:section:load',mapcutsInterests);

function mapcutsHeroCarousels(){document.querySelectorAll('.mc-map-carousel:not([data-ready])').forEach(root=>{
root.dataset.ready='true';const slides=[...root.querySelectorAll('.mc-map-slide')],controls=root.querySelector('.mc-map-controls'),toggle=root.querySelector('[data-rotation]'),count=root.querySelector('[data-count]'),track=root.querySelector('.mc-map-slides'),reduced=matchMedia('(prefers-reduced-motion: reduce)');if(slides.length<2)return;controls.hidden=false;let index=0,timer=null,stopped=root.dataset.autoplay==='false'||reduced.matches,hover=false,start=null;
const sync=()=>{clearInterval(timer);toggle.textContent=stopped?toggle.dataset.play:toggle.dataset.pause;track.setAttribute('aria-live',stopped?'polite':'off');if(!stopped&&!hover&&!document.hidden)timer=setInterval(()=>show(index+1),7000);};
const show=n=>{index=(n+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==index);count.textContent=(index+1)+' / '+slides.length;};
const stop=()=>{stopped=true;sync();};const move=delta=>{stop();show(index+delta);};
root.querySelector('[data-prev]').addEventListener('click',()=>move(-1));root.querySelector('[data-next]').addEventListener('click',()=>move(1));
let toggleNext=null;toggle.addEventListener('pointerdown',()=>{toggleNext=!stopped;});toggle.addEventListener('pointercancel',()=>{toggleNext=null;});toggle.addEventListener('click',()=>{stopped=toggleNext===null?!stopped:toggleNext;toggleNext=null;sync();});root.addEventListener('focusin',stop);root.addEventListener('mouseenter',()=>{hover=true;sync();});root.addEventListener('mouseleave',()=>{hover=false;sync();});root.addEventListener('touchstart',event=>{start={x:event.touches[0].clientX,y:event.touches[0].clientY};stop();},{passive:true});root.addEventListener('touchend',event=>{if(!start)return;const dx=event.changedTouches[0].clientX-start.x,dy=event.changedTouches[0].clientY-start.y;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))move(dx<0?1:-1);start=null;},{passive:true});document.addEventListener('visibilitychange',sync);reduced.addEventListener('change',()=>{if(reduced.matches)stop();});sync();
});}mapcutsHeroCarousels();document.addEventListener('shopify:section:load',mapcutsHeroCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapcuts-gallery"] && !Shopify.designMode) return;
  try {
    
function initMapGallery(){document.querySelectorAll('.mc-gallery:not([data-ready])').forEach(root=>{root.dataset.ready='true';const cards=[...root.querySelectorAll('[data-card]')],filters=[...root.querySelectorAll('select')],dialog=root.querySelector('dialog'),viewer=root.querySelector('[data-viewer]');let active=0,opener,overflow;const visible=()=>cards.filter(c=>!c.hidden);let shown=12;const more=root.querySelector('.mc-gallery-more');const fold=()=>{visible().forEach((c,i)=>c.toggleAttribute('data-folded',i>=shown));more.hidden=visible().length<=shown;};more.addEventListener('click',()=>{shown+=12;fold();});fold();root.querySelector('.mc-gallery-filters').hidden=false;filters.forEach(select=>{[...select.options].forEach(o=>{if(o.value!=='all'&&!cards.some(c=>c.dataset[select.dataset.filter]===o.value))o.remove();});if(select.options.length<=2)select.closest('label').hidden=true;select.addEventListener('change',()=>{cards.forEach(c=>c.hidden=!filters.every(f=>f.value==='all'||c.dataset[f.dataset.filter]===f.value));shown=12;fold();const count=visible().length;root.querySelector('.mc-gallery-empty').hidden=count>0;const status=root.querySelector('[role=status]');status.textContent=count+' '+status.dataset.countLabel;});});const show=()=>{viewer.querySelectorAll('video').forEach(v=>v.pause());viewer.replaceChildren(visible()[active].querySelector('template').content.cloneNode(true));root.querySelector('[data-position]').textContent=(active+1)+' / '+visible().length;};cards.forEach(card=>card.querySelector('.mc-gallery-open').addEventListener('click',e=>{e.preventDefault();opener=e.currentTarget;active=visible().indexOf(card);show();overflow=document.body.style.overflow;dialog.showModal();document.body.style.overflow='hidden';root.querySelector('[data-close]').focus();}));const move=delta=>{active=(active+delta+visible().length)%visible().length;show();};root.querySelector('[data-prev]').addEventListener('click',()=>move(-1));root.querySelector('[data-next]').addEventListener('click',()=>move(1));root.querySelector('[data-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>{viewer.querySelectorAll('video').forEach(v=>v.pause());viewer.replaceChildren();document.body.style.overflow=overflow;opener?.focus();});dialog.addEventListener('keydown',e=>{if(e.target.tagName==='VIDEO')return;if(e.key==='ArrowRight'){e.preventDefault();move(1);}if(e.key==='ArrowLeft'){e.preventDefault();move(-1);}});let start;viewer.addEventListener('touchstart',e=>{if(e.target.tagName==='IMG')start=[e.touches[0].clientX,e.touches[0].clientY];else start=null;},{passive:true});viewer.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start[0],dy=e.changedTouches[0].clientY-start[1];if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy))move(dx<0?1:-1);start=null;},{passive:true});});}initMapGallery();document.addEventListener('shopify:section:load',initMapGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapcuts-lake-customizer"]) return;
  try {
    
function initMapcutsGallery(root) {
  root.querySelectorAll('.mc-custom').forEach(section => {
    const dialog = section.querySelector('.mc-gallery-dialog');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const photos = [...section.querySelectorAll('[data-gallery-src]')];
    const image = dialog.querySelector('[data-gallery-image]');
    const slider = section.querySelector('.mc-photo-slider');
    const slideTo = direction => slider.scrollTo({left: Math.max(0, Math.min(photos.length - 1, Math.round(slider.scrollLeft / slider.clientWidth) + direction)) * slider.clientWidth, behavior: 'smooth'});
    section.querySelector('[data-slide-prev]').addEventListener('click', () => slideTo(-1));
    section.querySelector('[data-slide-next]').addEventListener('click', () => slideTo(1));
    slider.addEventListener('scroll', () => { section.querySelector('[data-slide-count]').textContent = `${Math.round(slider.scrollLeft / slider.clientWidth) + 1} / ${photos.length}`; }, {passive:true});
    slider.addEventListener('keydown', event => { if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();slideTo(event.key === 'ArrowRight' ? 1 : -1);} });
    let index = 0, opener, touchX, touchY;
    const show = value => {
      index = (value + photos.length) % photos.length;
      image.src = photos[index].dataset.gallerySrc;
      image.alt = photos[index].dataset.galleryAlt || '';
      dialog.querySelector('[data-gallery-count]').textContent = `${index + 1} / ${photos.length}`;
      dialog.querySelector('[data-gallery-caption]').textContent = image.alt;
    };
    section.querySelectorAll('[data-gallery-index]').forEach(button => button.addEventListener('click', () => {
      opener = button;
      show(Number(button.dataset.galleryIndex));
      dialog.showModal();
    }));
    dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => opener?.focus());
    dialog.querySelector('[data-gallery-prev]').addEventListener('click', () => show(index - 1));
    dialog.querySelector('[data-gallery-next]').addEventListener('click', () => show(index + 1));
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    const stage = dialog.querySelector('.mc-gallery-stage');
    stage.addEventListener('touchstart', event => {
      if (event.touches.length !== 1) { touchX = undefined; return; }
      touchX = event.touches[0].clientX; touchY = event.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', event => {
      if (touchX === undefined) return;
      const dx = event.changedTouches[0].clientX - touchX;
      const dy = event.changedTouches[0].clientY - touchY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
      touchX = undefined;
    }, { passive: true });
  });
}
initMapcutsGallery(document);
document.addEventListener('shopify:section:load', event => initMapcutsGallery(event.target));

if (!customElements.get('mapcuts-customizer')) {
  customElements.define('mapcuts-customizer', class extends HTMLElement {
    disconnectedCallback() { this.ratingObserver?.disconnect(); }
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const summary = this.closest('.mc-custom').querySelector('[data-top-rating]');
      const refreshRating = () => {
        const source = document.querySelector('.fera-reviews-header-summary');
        const rating = source?.querySelector('.fera-averageRating-average-number')?.textContent.trim();
        const count = source?.querySelector('.fera-averageRating-count-total')?.textContent.trim();
        if (!rating || !count) return;
        const text = `★ ${rating} (${count})`;
        if (summary.querySelector('button').textContent !== text) summary.querySelector('button').textContent = text;
        summary.hidden = false;
      };
      summary.querySelector('button').addEventListener('click', () => document.querySelector('.fera-reviews-header-summary')?.scrollIntoView({behavior:'smooth', block:'center'}));
      refreshRating();
      this.ratingObserver = new MutationObserver(refreshRating);
      this.ratingObserver.observe(document.body, {childList:true, subtree:true, characterData:true});
      const form = this.querySelector('form');
      const button = form.querySelector('button[type=submit]');
      const variant = form.querySelector('[name=id]');
      const status = this.querySelector('[data-status]');
      const choices = [...form.querySelectorAll('[data-product-option]')];
      let busy = false;
      const syncVariant = () => {
        const values = choices.map(choice => choice.value);
        const match = [...variant.options].find(option => JSON.parse(option.dataset.options).every((value, index) => value === values[index]));
        variant.value = match?.value || '';
        this.closest('.mc-custom').querySelectorAll('[data-price-output]').forEach(output => { output.textContent = match?.dataset.price || this.dataset.unavailable; });
        button.disabled = busy || !match || match.disabled;
        if (!busy) button.textContent = !match || match.disabled ? this.dataset.unavailable : button.dataset.idle;
      };
      const picker = form.querySelector('.mc-price-picker');
      let pickerOpener;
      picker.querySelector('[data-picker-close]').addEventListener('click', () => picker.close());
      picker.addEventListener('close', () => pickerOpener?.focus());
      choices.forEach((choice, optionIndex) => {
        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'mc-price-trigger';
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-label', choice.labels[0].textContent.trim());
        trigger.textContent = choice.selectedOptions[0].textContent + ' ▾';
        choice.hidden = true;
        choice.after(trigger);
        choice.addEventListener('change', () => { trigger.textContent = choice.selectedOptions[0].textContent + ' ▾'; syncVariant(); });
        trigger.addEventListener('click', () => {
          pickerOpener = trigger;
          picker.querySelector('h2').textContent = choice.labels[0].textContent;
          const rows = picker.querySelector('[data-picker-rows]');
          rows.replaceChildren();
          [...choice.options].forEach(option => {
            const matches = [...variant.options].filter(v => !v.disabled && JSON.parse(v.dataset.options)[optionIndex] === option.value).sort((a,b) => Number(a.dataset.cents) - Number(b.dataset.cents));
            const row = document.createElement('button');
            row.type = 'button'; row.className = 'mc-price-row';
            row.disabled = !matches.length;
            row.setAttribute('aria-pressed', String(choice.value === option.value));
            const label = document.createElement('span'); label.textContent = option.textContent;
            const price = document.createElement('strong');
            price.textContent = !matches.length ? this.dataset.unavailable : matches[0].dataset.cents === matches[matches.length - 1].dataset.cents ? matches[0].dataset.price : matches[0].dataset.price + ' – ' + matches[matches.length - 1].dataset.price;
            row.append(label, price);
            row.addEventListener('click', () => { choice.value = option.value; choice.dispatchEvent(new Event('change', {bubbles:true})); picker.close(); });
            rows.append(row);
          });
          picker.showModal();
        });
      });
      syncVariant();
      form.querySelectorAll('input[type=file]').forEach(input => input.addEventListener('change', () => {
        const file = input.files[0];
        input.setCustomValidity(file && (!['image/jpeg', 'image/png'].includes(file.type) || file.size > 10 * 1024 * 1024) ? input.dataset.fileError : '');
        input.reportValidity();
      }));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (button.disabled || !form.reportValidity()) return;
        busy = true;
        button.disabled = true;
        button.textContent = button.dataset.busy;
        status.textContent = '';
        this.querySelector('[data-cart-link]').hidden = true;
        try {
          const data = new FormData(form);
          for (const [key, value] of [...data.entries()]) {
            if ((typeof value === 'string' && !value.trim()) || (value instanceof File && !value.size)) data.delete(key);
          }
          const response = await fetch(this.dataset.addUrl, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : status.dataset.error);
          status.textContent = status.dataset.success;
          this.querySelector('[data-cart-link]').hidden = false;
        } catch (error) {
          status.textContent = error.message || status.dataset.error;
        } finally {
          busy = false;
          syncVariant();
        }
      }, true);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapcuts-navigation"]) return;
  try {
    
document.querySelectorAll('.mc-navigation').forEach(header=>{const menus=[...header.querySelectorAll('.mc-menu')];menus.forEach(menu=>menu.addEventListener('toggle',()=>{if(menu.open)menus.forEach(other=>{if(other!==menu)other.open=false})}));document.addEventListener('click',event=>{if(!header.contains(event.target))menus.forEach(menu=>menu.open=false)});header.addEventListener('keydown',event=>{if(event.key==='Escape')menus.forEach(menu=>{if(menu.open){menu.open=false;menu.querySelector('summary').focus()}})})});
document.querySelectorAll('.mc-navigation').forEach(header=>{const dialog=header.querySelector('.mc-mobile-drawer'),toggle=header.querySelector('.mc-menu-toggle'),close=header.querySelector('.mc-menu-close');if(!dialog||!toggle||!close)return;header.classList.add('mc-js-nav');let previousOverflow='';toggle.addEventListener('click',()=>{previousOverflow=document.body.style.overflow;dialog.showModal();document.body.style.overflow='hidden';close.focus()});close.addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()}});dialog.addEventListener('close',()=>{document.body.style.overflow=previousOverflow;toggle.focus()});window.matchMedia('(min-width:750px)').addEventListener('change',event=>{if(event.matches&&dialog.open)dialog.close()})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapcuts-product-guide"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mc-mobile-buy button').forEach(button=>button.addEventListener('click',()=>{const target=document.querySelector('.product__info-container');if(target){target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});target.setAttribute('tabindex','-1');target.focus({preventScroll:true})}}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapcuts-video-stories"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('play',event=>{if(event.target.matches('.mc-video-card video'))document.querySelectorAll('.mc-video-card video').forEach(video=>{if(video!==event.target)video.pause()})},true);

  } catch(e) { console.error(e); }
})();
})();
